import { z } from "zod";
import formatStringNumberToNumber from "../components/utils/formatStringNumberToNumber";

const formEditClaniceFinanceRealiziranoSchema = z
  .object({
    realiziranaVrednost: z.preprocess(
      (value) => formatStringNumberToNumber(value),
      z.number().nullable().optional(),
    ),
    realiziranaLastnaVrednost: z.preprocess(
      (value) => formatStringNumberToNumber(value),
      z.number().nullable().optional(),
    ),
    realiziranaVrednostViri: z.preprocess(
      (value) => formatStringNumberToNumber(value),
      z.number().nullable().optional(),
    ),
    realiziranaObseg: z.preprocess(
      (value) => (isNaN(value) ? null : value),
      z.number().nullable().optional(),
    ),
  })
  .superRefine(
    (
      {
        realiziranaVrednost,
        realiziranaLastnaVrednost,
        realiziranaVrednostViri,
      },
      ctx,
    ) => {
      const sestevekVrednostiVirov =
        (realiziranaLastnaVrednost || 0) + (realiziranaVrednostViri || 0);
      if (sestevekVrednostiVirov > realiziranaVrednost) {
        ctx.addIssue({
          message:
            "Lastno sofinanciranje in sofinanciranje iz projektnega vira ne smeta presegati vrednosti projekta",
          path: ["realiziranaVrednost"],
        });
      }
    },
  );

export default formEditClaniceFinanceRealiziranoSchema;
